import { useLazyQuery } from '@apollo/client';

import { OrderType, SalesOrderFilterInput, }
  from '@/graphql/contracts/_generated_/contracts';
import GetPaginatedFilteredSalesOrdersBCQuery from '@/graphql/contracts/getPaginatedFilteredSalesOrdersBC.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { encodePaginationPageToBase64 } from '@/pages/ImportingTool/FileDetails/helpers/getUsageDetailsHelpers';
import { GetPaginatedFilteredSalesOrdersBC, GetPaginatedFilteredSalesOrdersBCVariables }
  from '@/graphql/contracts/_generated_/getPaginatedFilteredSalesOrdersBC.query';

export type PaginatedFilteredSalesOrders = {
  after?: number;
  first?: number;
  sort?: { field?: string; order: OrderType }[];
  group?: string;
  filter?: SalesOrderFilterInput;
  before?: string;
  last?: number;
};

export default function useGetFilteredBCSalesOrders() {
  const [_getBCSalesOrders, { loading, data, error }] =
    useLazyQuery<GetPaginatedFilteredSalesOrdersBC, GetPaginatedFilteredSalesOrdersBCVariables>(
      GetPaginatedFilteredSalesOrdersBCQuery,
      {
        client: apolloClientContracts,
        fetchPolicy: 'network-only',
        onError: (err) =>
          notificationService.open({
            title: 'Error',
            text: err.message,
            type: 'danger',
          }),
      });

  const getFilteredBCSalesOrders = async (params: PaginatedFilteredSalesOrders) => {
    const response = await _getBCSalesOrders({
      variables: {
        ...params,
        after: params?.after
          ? encodePaginationPageToBase64(params.after)
          : undefined,
      } as GetPaginatedFilteredSalesOrdersBCVariables,
    });

    return response?.data?.paginatedFilteredSalesOrdersByBillingCycles;
  };

  return {
    getFilteredBCSalesOrders: getFilteredBCSalesOrders,
    paginatedFilteredBCSalesOrders: data?.paginatedFilteredSalesOrdersByBillingCycles,
    isLoadingGetBCSalesOrders: loading,
    errorLoadingBCSalesOrders: error
  };
}